<template>
  <div class="panel" :style="'width:' + width +'px;'">
    <div v-if="title" class="title"> {{ title }} </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Panel",
  props: ['title', 'width']
};
</script>

<style lang="scss" scoped>
@import "./../../styles/colors";
.panel {
  padding: 10px;
  border: 1px solid $color-border;
  border-radius: 4px;
  position: relative;
  .title {
    position: absolute;
    font-size: 14px;
    font-weight: 700;
    top: -14px;
    left: 8px;
    background: white;
    padding: 5px 6px;
  }
}
</style>
